import ArraySnippetInterface from './array-snippet-interface';

class ArraySnippet implements ArraySnippetInterface {
    constructor(
        private startColumnNumber: number = 0,
        private startRowNumber: number = 0,
        private columnsQuantity: number | null = null,
        private rowsQuantity: number | null = null,
    ) {}

    makeSnippet(content: string[][]): string[][] {
        const snippet: string[][] = [];

        const rows = this.sliceArrayByRows(content);
        rows.map((row) => {
            snippet.push(this.sliceArrayByColumns(row));
        });

        return snippet;
    }

    private sliceArrayByRows(content: string[][]): string[][] {
        if (this.rowsQuantity === null) {
            return content.slice(this.startRowNumber);
        }

        return content.slice(this.startRowNumber, this.rowsQuantity);
    }

    private sliceArrayByColumns(row: string[]): string[] {
        if (this.columnsQuantity === null) {
            return row.slice(this.startColumnNumber);
        }

        const lastColumnNumber = this.startColumnNumber + this.columnsQuantity;

        return row.slice(this.startColumnNumber, lastColumnNumber);
    }
}

export default ArraySnippet;
